/** Isotipo: tres barras de alturas crecientes — la escalera papel → canario →
 *  vivo (docs/rediseno-frontend/README.md, "Firma visual"). Roja/ámbar/cian a
 *  propósito: son los tres registros de la app (pérdida, alerta, telemetría),
 *  no un degradé decorativo. Inline, sin imagen: toma los tokens del tema y
 *  escala con `font-size`. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={`brand-mark${className ? ` ${className}` : ''}`} aria-hidden="true">
      <span className="brand-mark__bar brand-mark__bar--1" />
      <span className="brand-mark__bar brand-mark__bar--2" />
      <span className="brand-mark__bar brand-mark__bar--3" />
    </span>
  )
}

/** `horizontal`: isotipo + nombre en línea (barra lateral, formularios).
 *  `stacked`: isotipo arriba, nombre abajo (momentos de marca).
 *
 *  Por default el texto toma el color del tema; `force` es para un fondo que
 *  es oscuro (o claro) a propósito, sin importar el tema de la app. */
export function BrandLogo({
  variant,
  className,
  force,
}: {
  variant: 'horizontal' | 'stacked'
  className?: string
  force?: 'light' | 'dark'
}) {
  const classes = [
    'brand-logo',
    `brand-logo--${variant}`,
    force ? `brand-logo--on-${force}` : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} role="img" aria-label="Deltabot">
      <BrandMark />
      <span className="brand-logo__word" aria-hidden="true">
        Deltabot
      </span>
    </span>
  )
}
